export * from "@trydig/next/i18n/client";
